import { Injectable } from '@angular/core';
import { DataService } from 'src/app/shared/session';
import { SessionInfo } from 'src/app/shared/session/SessionInfo';
import { Region } from './region.model';
import { HttpParams } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class RegionService {

  constructor(private dataService: DataService, private sessionInfo: SessionInfo) { }

  private insertarRegionUrl: string = 'region/insertar';
  private actualizarRegionUrl: string = 'region/actualizar';
  private obtenerRegionUrl: string = 'region/obtener';
  private listarRegionPorUrl: string = 'region/listarPor';

  insertarRegion(region: Region): any {
    let parameters: string;
    parameters = JSON.stringify({
      nombre: region.nombre,
      idEmpresa: this.sessionInfo.getEmpresaID(),
      userCreation: this.sessionInfo.getCodUsuario(),
    });
    this.dataService.set(this.insertarRegionUrl);
    return this.dataService.execPostJson(parameters);
  }

  actualizarRegion(region: Region): any {
    let parameters: string;
    parameters = JSON.stringify({
      id: region.id,
      nombre: region.nombre,
      userLastUpdate: this.sessionInfo.getCodUsuario(),
    });
    this.dataService.set(this.actualizarRegionUrl);
    return this.dataService.execPostJson(parameters);
  }

  obtenerRegion(id: number): any {
    let parameters = new HttpParams();
    parameters = parameters.append("pKey", String(id));
    this.dataService.set(this.obtenerRegionUrl);
    return this.dataService.execGetJson(parameters);
  }

  listarRegion(filtro: string): any {
    let parameters = new HttpParams();
    parameters = parameters.append("pFiltro", filtro);
    parameters = parameters.append("idEmpresa", String(this.sessionInfo.getEmpresaID()));
    this.dataService.set(this.listarRegionPorUrl);
    return this.dataService.execGetJson(parameters);
  }
}
